export function capitalizeFirstLetter(value: string) {
  const str = value.toLowerCase();
  return str?.charAt(0).toUpperCase() + str?.slice(1);
}
